import React from 'react';
import { MDIIconButton } from '../MDIIconButton';
import { PopoverTooltip, usePopoverTooltip } from '../PopoverTooltip';
import { type IconWithTooltipProps } from './IconWithTooltip.types';

const IconWithTooltip: React.FC<IconWithTooltipProps> = (props) => {
  const { title, ...rest } = props;
  const popoverTooltip = usePopoverTooltip();
  return (
    <>
      <MDIIconButton {...rest} ref={popoverTooltip.setTriggerRef} title="" />
      <PopoverTooltip
        {...popoverTooltip}
        tooltipContainerClassName={props.tooltipContainerClassName}
      >
        {title}
      </PopoverTooltip>
    </>
  );
};

export default IconWithTooltip;
